export default __webpack_public_path__ + "advantage-2ada3f3.png";